import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-cart1-icon',
  templateUrl: './shopping-cart1.component.html'
})
export class ShoppingCart1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
